export default "__VITE_ASSET__985d2d68__"